const PAYMENT_METHOD_GET_LIST_REQUEST = 'PAYMENT_METHOD_GET_LIST_REQUEST'
const PAYMENT_METHOD_GET_LIST_SUCCESS = 'PAYMENT_METHOD_GET_LIST_SUCCESS'
const PAYMENT_METHOD_GET_LIST_FAILED = 'PAYMENT_METHOD_GET_LIST_FAILED'

export default {
  PAYMENT_METHOD_GET_LIST_REQUEST,
  PAYMENT_METHOD_GET_LIST_SUCCESS,
  PAYMENT_METHOD_GET_LIST_FAILED
}
